import type { z } from 'zod'

/**
 * 檢查值的型別是否符合 Zod Schema
 *
 * @param value 要檢查的值
 * @param zodSchema Zod 型別 Schema
 * @param consoleError Zod 解析錯誤時，是否 console 錯誤訊息
 */
export function isType<T extends z.ZodType>(
  value: unknown,
  zodSchema: T,
  consoleError = false
): value is z.infer<T> {
  const result = zodSchema.safeParse(value)

  if (!result.success && consoleError) {
    const errorData = {
      message: 'is-type 型別檢查錯誤',
      data: value,
      result
    }
    console.error(errorData)
    console.error(result.error.message)
  }

  return result.success
}
